import type { Post } from "./types";

/**
 * 削除・非表示になった投稿の本文を、手元に残った古い表示から再び出さないための印。
 * 一度でも「使えない」と返ってきた投稿 ID は、このタブを閉じるまで本文を出さない（仕様書「おすすめを投稿する」、A11）。
 * 保存はしない（端末に残さない）。
 */
const redacted = new Set<string>();

export function noteRedacted(post: Pick<Post, "id" | "unavailable"> | null | undefined): void {
  if (post?.unavailable) redacted.add(post.id);
}

/** 一覧などを受け取ったときに通す。使えない投稿を印に足し、本文を落とした形にそろえる */
export function scrubPost<T extends Post | null | undefined>(post: T): T {
  if (!post) return post;
  if (post.unavailable) redacted.add(post.id);
  if (redacted.has(post.id) && post.body !== null) {
    return { ...post, body: null, unavailable: true, moments: [] };
  }
  return post;
}

/** 本文を出してよいときだけ文字を返す */
export function visibleBody(post: Post | null | undefined): string | null {
  if (!post || post.unavailable || redacted.has(post.id)) return null;
  return post.body;
}

/** テスト用 */
export function resetRedactedForTest(): void {
  redacted.clear();
}
